module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/table-12158d57341885fead5c2093260963f5.svg";